import React from 'react';

import type { CouponStatus } from 'js/src/client';
import Callout, { CALLOUT_TYPES } from 'js/src/components/common/ui/Callout';

export function CouponNode(props: { couponStatus: CouponStatus | null }) {
    if (props.couponStatus === null || props.couponStatus.valid === undefined) {
        return null;
    }
    if (props.couponStatus.valid) {
        return (
            <Callout msgType={CALLOUT_TYPES.INFO}>
                <strong>Discount successfully applied!</strong>
                <br />
                {props.couponStatus.id} gives you&nbsp;
                <strong>
                    {props.couponStatus.discount} off {props.couponStatus.duration}
                </strong>
            </Callout>
        );
    } else {
        return (
            <Callout msgType={CALLOUT_TYPES.ERROR}>
                Discount <strong>{props.couponStatus.id}</strong> is not valid
            </Callout>
        );
    }
}
